import React, { Component } from "react";
import ComponentList, { PAGE_SIZE, PAGE_TYPE } from "./ComponentList";
import ComponentManager from "./ComponentManager";
import Editor from "./editors/Editor";
import Canvas from "./Canvas";
import { getViewportSize } from "../../utility/ViewportSizeUtils";
import { VIEWPORT_SIZES } from "../../constants/Constant";
import "./designer.scss";
/*
PROPS
- components
- onDataChange
- onSave
- type (PAGE_TYPE)
- previewMode (true/false)
- readOnly
- hash
*/

class PageDesigner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      components: this.props.components,
      scripts: this.props.scripts,
      metaData: this.props.metaData,
      needEditor: false,
      currentComponentIndex: null,
      currentComponentData: null,
      viewType:
        this.props.type === PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE ||
        this.props.type === PAGE_TYPE.FUNNEL
          ? PAGE_SIZE.WEB
          : PAGE_SIZE.TABLET,
      previewMode: this.props.previewMode,
      readOnly: this.props.readOnly ? this.props.readOnly : false,
      isInlineEdit: true,
      isViewTypeEditor: false
    };

    this.elementsInEditScope = "#canvas, #page-designer-editor";
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      components: nextProps.components,
      scripts: nextProps.scripts,
      metaData: nextProps.metaData,
      currentComponentIndex: null,
    },()=>{
      this.passDataToParent()
    });
    this.hideEditor();
    this.scrollToTop();

    if (this.state.addComponent !== nextProps.addComponent) {
      if (nextProps.addComponent !== null) {
        this.setState({ addComponent: nextProps.addComponent });
        this.componentAdded(nextProps.addComponent);
      }
    }
    if (this.state.viewType !== nextProps.viewType) {
      if(!this.state.isViewTypeEditor) {this.windowSizeUpdated()}
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.onKeyboardButtonTapped);
    document.addEventListener("mouseup", this.onClickHandler);
    window.addEventListener("resize", this.windowSizeUpdated);
    this.windowSizeUpdated()
    setTimeout(() => {
      this.passDataToParent();
    }, 100);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyboardButtonTapped);
    document.removeEventListener("mouseup", this.onClickHandler);
    window.removeEventListener("resize", this.windowSizeUpdated);
  }
  onKeyboardButtonTapped = (evt) => {
    if (evt.keyCode === 27) {
      this.hideEditor();
    }
  };

  windowSizeUpdated = (e) => {
    let viewType = "";
    switch (getViewportSize()) {
      case VIEWPORT_SIZES.EXTRA_SMALL:
        viewType = PAGE_SIZE.PHONE;
        break;
      case VIEWPORT_SIZES.SMALL:
      default:
        if (this.props.type === PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE ||
            this.props.type === PAGE_TYPE.FUNNEL) {
          viewType = PAGE_SIZE.WEB;
        } else {
          viewType = PAGE_SIZE.TABLET;
        }
    }
    this.setState({viewType: viewType});
  };

onClickHandler = (event) => {
    const target = event.target;
    const editingContainer =
      target.closest && target.closest(this.elementsInEditScope);

    if (!editingContainer) {
      this.hideEditor();
    }
  };

  scrollToBottom() {
    setTimeout(() => {
      const canvas_holder = document.getElementById("canvas-holder");
      const canvas = document.getElementById("canvas");
      canvas_holder.scrollTop = canvas.offsetHeight;
    }, 100);
  }
  scrollToTop() {
    const canvas_holder = document.getElementById("canvas-holder");
    canvas_holder.scrollTop = 0;
  }

  render() {
    return (
      <div
        className={
          "row align-items-start justify-content-center position-relative " +
          (this.state.previewMode ? "" : "mt-xl")
        }
        style={{ height: this.state.previewMode ? "100%" : "90%" }}
      >
        <div
          id="dummy-focus-div"
          tabIndex="-1"
          className="position-absolute z-index-2"
          style={{
            width: 0,
            height: 0,
            top: 50,
            left: 150,
            outline: "none",
          }}
        />
        <div
          id="canvas-holder"
          className={
            "column flex-1 align-items-center bg-gray3 border-box position-relative hide-scroll-bar " +
            (this.state.previewMode ? "" : "p-xl border-radius-s padding-empty-mobile padding-top-mobile")
          }
          style={{
            backgroundColor: this.state.previewMode
              ? "transparent"
              : "rgb(226, 230, 234)",
            overflowY: "scroll",
            height: "100%",
            outline: "none",
          }}
        >
          {this.componentsHolder()}
        </div>
        <div
          className="hide-scroll-bar"
          style={{ height: "100%", overflowY: "scroll", marginBottom: 10 }}
        >
          {!this.state.readOnly &&
            !this.state.previewMode &&
            !this.state.needEditor &&
            this.elementList()}
        </div>
        {!this.state.readOnly &&
          !this.state.previewMode &&
          this.state.needEditor &&
          this.editor()}
      </div>
    );
  }

  showEditor = () => {
    this.setState({
      needEditor: true,
    });
  };
  hideEditor = () => {
    this.setState({
      needEditor: false,
      currentComponentIndex: null,
      currentComponentData: null,
    });
  };

  elementList() {
    return (
      <ComponentList
        pageType={this.props.type}
        onAdd={this.componentAdded}
        viewType={this.state.viewType}
        components={this.state.components}
        scripts={this.state.scripts}
        metaData={this.state.metaData}
        onViewTypeChange={(type) => {
          this.setState({ viewType: type, isViewTypeEditor: true });
        }}
        onScriptAdd={(data) => {
          this.scriptAdded(data);
        }}
        onMetaDataAdd={(data) => {
          this.metaDataAdded(data);
        }}
      />
    );
  }
  editor() {
    return (
      <Editor
        data={this.state.currentComponentData}
        pageType={this.props.type}
        isInlineEdit={this.props.isInlineEdit}
        onDataChange={(data) => this.onDataChange(data)}
        onClose={this.hideEditor}
        onDelete={this.onDeleteComponent}
      />
    );
  }

  componentsHolder() {
    return (
      <Canvas
        readOnly={this.state.readOnly}
        previewMode={this.state.previewMode}
        pageType={this.props.type}
        currentComponentIndex={this.state.currentComponentIndex}
        components={this.state.components}
        scripts={this.state.scripts}
        metaData={this.state.metaData}
        onComponentSelect={(index, isInlineEdit) => {
          if (!this.state.readOnly && !this.state.previewMode) {
            this.setState(
              {
                currentComponentIndex: index,
                currentComponentData: this.state.components[index],
                needEditor: false,
                isInlineEdit: isInlineEdit
              },
              this.showEditor
            );
          }
        }}
        onTapOutside={this.hideEditor}
        viewType={this.state.viewType}
        onSave={() => {
          this.hideEditor();
          if(this.props.onSave) {
            this.props.onSave();
          }          
        }}
        onDataChange={(data) => this.onDataChange(data)}
        onCopyComponent={(data) => this.onCopyComponent(data)}
        hash={this.props.hash}
        onDeleteCanvasComponent={(index) => this.onDeleteCanvasComponent(index)}
        width={'auto'}
      />
    );
  }

  scriptAdded = (data) => {
    this.setState(
      {
        scripts: data,
      },
      this.passDataToParent
    );
  };

  metaDataAdded = (data) => {
    this.setState(
      {
        metaData: data,
      },
      this.passDataToParent
    );
  };

  componentAdded = (type) => {
    let components = this.state.components;
    components.push(ComponentManager.getComponentDefaultData(type));
    this.setState(
      {
        components: components,
      },
      this.passDataToParent
    );
    this.scrollToBottom();
  };

  onDataChange = (data) => {
    let components = [...this.state.components];
    components[this.state.currentComponentIndex] = data;
    this.setState({ components: components }, this.passDataToParent);
  };

  onDeleteComponent = () => {
    let components = this.state.components;
    components.splice(this.state.currentComponentIndex, 1);
    this.setState({ components: components }, this.passDataToParent);
    this.hideEditor();
  };

  onCopyComponent = (components) => {
    this.setState({ components: components }, this.passDataToParent);
    this.hideEditor();
  };

  onDeleteCanvasComponent = (index) => {
    if (index === undefined) {
      return;
    }
    this.setState({ currentComponentIndex: index });
    this.onDeleteComponent();
  };

  passDataToParent = () => {
    const data = {
      segmentId: this.getSegmentId(),
      json: {
        scripts: this.state.scripts,
        metaData: this.state.metaData,
        hash: this.props.hash,
        designElements: this.state.components,
      },
      html: null,
      hash: this.props.hash,
      pipelineId: this.getPipelineId()
    };

    this.props.onDataChange(data);
  };

  getSegmentId = () => {
    let data = (this.state.components || []).find(
      (item) => item.type?.toLowerCase() === this.props.type?.toLowerCase()
    );
    return data ? data.segmentId : "";
  };
  getPipelineId = () => {
    let data = (this.state.components || []).find(
      (item) => item.type?.toLowerCase() === this.props.type?.toLowerCase()
    );
    return data ? data.pipelineId : [];
  }
}

export default PageDesigner;
